export enum LegListDialogTabsEnum {
  General = 0,
  Bookings = 1,
  Pricing = 2,
}
